/* tslint:disable:no-console */
import Backbone from 'backbone'
import _ from 'underscore'
import $ from 'jquery'
import Core from '../core'

class ImageView extends Backbone.View {
    // repeat = false

    initialize (options) {
        try {
            this.repeat = false

            this.executed = false

            // Evento disparado pelo modulo Lazyloading
            this.on(Core.Events.SHOW_ELEMENT, this.render, this)

            // Cadastra essa view no Modulo de Lazyloading
            Core.Modules.get('Lazyloading').addView(this)
        } catch (ex) {
            console.error(ex)
        }
    }

    render () {
        this.executed = true
        try {
            const objs = $(this.el).find('source,img')
            _.each(objs, (obj) => {
                const element = $(obj)
                const dataSrcset = element.attr('data-srcset')
                element.attr('srcset', dataSrcset)

                if (element.prop('nodeName') === 'IMG') {
                    const src = element.attr('data-src')
                    element.attr('src', src)

                    element.on('load', () => {
                        if ($('body').has('#section-vozes')) {
                            element.parent().parent().removeClass('img-fallback')
                        }

                        element.parent().removeClass('img-fallback')
                    })
                }
            })
        } catch (ex) {
            console.error(ex)
        }
    }
}

export default ImageView
